"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaignNameTable = void 0;
const helper_1 = require("./helper");
const campaignNameTable = (dateRange, filters) => (0, helper_1.getTableQuery)(['Attribution.campaign'], dateRange, filters);
exports.campaignNameTable = campaignNameTable;
//# sourceMappingURL=campaignName.js.map